import script from "./VMenuPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./VMenuPanel.vue?vue&type=script&setup=true&lang=js"

import "./VMenuPanel.vue?vue&type=style&index=0&id=b772926a&lang=scss"

const __exports__ = script;

export default __exports__